import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { MapUtils } from "../../utils/map.utils";
import { FormUtils } from "../../utils/form.utils";
import { CustomValidators } from "./beachValidation";
import { Globals } from "../../common/global";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-beach-create-booking",
  templateUrl: "./beach-create-booking.component.html",
  styleUrls: ["./beach-create-booking.component.css"],
})
export class BeachCreateBookingComponent implements OnInit {
  beachForm!: FormGroup;
  submitted = false;
  beachImage: File | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  zoneImagePreviews: (string | ArrayBuffer | null)[] = [];
  map: any;
  lat: number = 0;
  lng: number = 0;
  selectedLocation: string = "";
  showLocationError: boolean = false;
  showZoneForm: boolean = false;
  today: string = new Date().toISOString().split("T")[0];
  id: string | null = null;
  existingImageUrl: string | null = null;
  durations = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  zoneTypes: { id: string; name: string }[] = [];
  categoryList: any = [];
  private categoryChangeSubscription: any;

  @ViewChild("zoneWarningModal") zoneWarningModal: any;
  @ViewChildren("zoneFileInput") zoneFileInputs!: QueryList<ElementRef>;

  slotDurations = ["Full-day", "Hourly"];
  private _id: string = "";
  beachData: any;
  locktypes: any = [];
  operator_id: any;
  isEdit: boolean = false;
  locationList: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    public Globals: Globals,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.operator_id = this.Globals.getUser()._id;
    this.getLockTypes();
    this.getLocationList();
    this.initializeForm();
    this.initializeMap();
    this.spotCategoryList().then(() => {
      this.getParams();
    });
    this.checkSlotDuration();
  }

  private resetZoneTypeControls(enabled: boolean): void {
    this.zones.controls.forEach((zoneGroup) => {
      const zoneTypeControl = zoneGroup.get("subCategoryId");
      if (zoneTypeControl) {
        if (enabled) {
          zoneTypeControl.enable({ emitEvent: false });
        } else {
          zoneTypeControl.disable({ emitEvent: false });
          zoneTypeControl.setValue("");
        }
        zoneTypeControl.updateValueAndValidity();
      }
    });
  }

  onCategoryChange(): void {
    const selectedCategoryId = this.beachForm.get("categoryId")?.value;
    const selectedCategory = this.categoryList.find(
      (category: any) => category._id === selectedCategoryId
    );

    this.zoneTypes =
      selectedCategory?.subCategories?.map((sub: any) => {
        return { id: sub._id, name: sub.name };
      }) || [];

    this.zones.controls.forEach((zoneGroup) => {
      const zoneTypeControl = zoneGroup.get("subCategoryId");
      if (zoneTypeControl) {
        if (this.zoneTypes.length > 0) {
          zoneTypeControl.enable({ emitEvent: false });
        } else {
          zoneTypeControl.disable({ emitEvent: false });
          if (!this.isEdit) {
            zoneTypeControl.setValue("");
          }
        }
        zoneTypeControl.updateValueAndValidity();
      }
    });
  }

  getParams() {
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get("id")) {
        this._id = params.get("id") as string;
        this.isEdit = true;
        let url = ConfigApi.URLS.SPOT_BOOKING.DETAILS + "/" + this._id;
        let method = "GET";
        this.apiCallingService.callAPI({}, method, url).subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.beachData = res.data;
            this.populateFormWithData();
            this.onCategoryChange();
          }
        });
      }
    });
  }
  checkSlotDuration() {
    const slotDurationControl = this.beachForm.get("timing");
    const durationControl = this.beachForm.get("duration");

    if (slotDurationControl?.value === "Full-day") {
      durationControl?.setValue(1);
      durationControl?.disable();
    }

    slotDurationControl?.valueChanges.subscribe((value) => {
      if (value === "Full-day") {
        durationControl?.setValue(1);
        durationControl?.disable();
      } else {
        durationControl?.enable();
      }
    });
  }
  getLocationList() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.ADVANCE_BOOKING.LOCATION_LIST +
          `?operator_id=${this.operator_id}&search=`
      )
      .subscribe((res) => {
        this.locationList = res.data;
      });
  }

  spotCategoryList(): Promise<void> {
    return new Promise((resolve) => {
      this.apiCallingService
        .callAPI({}, "GET", ConfigApi.URLS.SPOT_BOOKING.SPOT_CATEGORY_LIST)
        .subscribe((res) => {
          if (res.data && res.data.length > 0) {
            this.categoryList = res.data;
            if (!this.isEdit) {
              this.beachForm.get("categoryId")?.valueChanges.subscribe(() => {
                this.onCategoryChange();
              });
            }
          }
          resolve();
        });
    });
  }

  populateFormWithData(): void {
    const beachData: any = this.beachData;

    this.beachForm.patchValue({
      title: beachData.title,
      description: beachData.description,
      assetType: beachData.assetType,
      bookingLocationId: beachData.bookingLocationId._id.toString(),
      categoryId: beachData.categoryId?._id,
      address: beachData.address,
      latitude: beachData.location.coordinates[1],
      longitude: beachData.location.coordinates[0],
      startDate: beachData.startDate,
      endDate: beachData.endDate,
      checkInTime: beachData.checkInTime,
      checkOutTime: beachData.checkOutTime,
      timing: beachData.timing,
      duration: beachData.duration,
      vatPercentage: beachData.vatPercentage,
      isExclusive: beachData.isExclusive,
    });

    if (beachData.location && beachData.location) {
      this.lat = beachData.location.coordinates[1];
      this.lng = beachData.location.coordinates[0];
      this.selectedLocation = beachData.address;
      setTimeout(() => this.initializeMap(), 100);
    }

    if (beachData.beachImage) {
      this.imagePreview = beachData.beachImage;
      this.beachImage = beachData.beachImage;
    }

    let PatchBlockedDates = beachData.blockedDates;

    if (PatchBlockedDates && PatchBlockedDates.length > 0) {
      PatchBlockedDates.forEach((date: string) => {
        this.beachBlockedDates.push(this.fb.control(date));
      });
    }

    this.onCategoryChange();

    setTimeout(() => {
      while (this.zones.length > 0) {
        this.zones.removeAt(0);
      }
      this.zoneImagePreviews = [];

      if (beachData.zones && beachData.zones.length > 0) {
        beachData.zones.forEach((zone: any, index: number) => {
          this.addZone();
          const zoneGroup = this.zones.at(index) as FormGroup;

          const zoneTypeControl = zoneGroup.get("subCategoryId");
          if (zoneTypeControl && this.zoneTypes.length > 0) {
            zoneTypeControl.enable({ emitEvent: false });
          }

          // Patch all zone values including subCategoryId
          zoneGroup.patchValue({
            zoneName: zone.zoneName,
            numOfRows: zone.numOfRows,
            numOfColumns: zone.numOfColumns,
            price: zone.price,
            zoneImage: zone.zoneImage || null,
            subCategoryId: zone.subCategoryId || "",
          });

          if (zoneTypeControl) {
            zoneTypeControl.updateValueAndValidity();
          }

          if (zone.zoneImage) {
            this.zoneImagePreviews[index] = zone.zoneImage;
          }

          const assetsArray = this.getAssetsArray(index);
          while (assetsArray.length > 0) {
            assetsArray.removeAt(0);
          }
          if (zone.assetsIncluded && zone.assetsIncluded.length > 0) {
            zone.assetsIncluded.forEach((asset: string) => {
              assetsArray.push(this.fb.control(asset));
            });
          }
        });
      }
    }, 200);
  }

  initializeForm(): void {
    const pastDateValidator = (control: AbstractControl) =>
      CustomValidators.pastDateValidator(control, this.isEdit);

    this.beachForm = this.fb.group({
      title: ["", [Validators.required, Validators.minLength(3)]],
      description: ["", [Validators.required, Validators.minLength(10)]],
      assetType: ["", Validators.required],
      address: ["", Validators.required],
      latitude: [
        "",
        [Validators.required, Validators.pattern(/^-?\d{1,3}\.\d+$/)],
      ],
      longitude: [
        "",
        [Validators.required, Validators.pattern(/^-?\d{1,3}\.\d+$/)],
      ],
      bookingLocationId: ["", Validators.required],
      categoryId: ["", Validators.required],
      startDate: ["", [Validators.required, pastDateValidator]],
      endDate: [
        "",
        [
          Validators.required,
          pastDateValidator,
          CustomValidators.dateAfterValidator("startDate"),
        ],
      ],
      blockedDates: this.fb.array(
        [],
        this.blockedDatesValidator("startDate", "endDate")
      ),
      checkInTime: ["", Validators.required],
      checkOutTime: [
        "",
        [
          Validators.required,
          CustomValidators.timeAfterValidator("checkInTime"),
        ],
      ],
      timing: [this.slotDurations[0], Validators.required],
      vatPercentage: [
        null,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      duration: ["1", [Validators.required]],
      isExclusive: [true],
      zones: this.fb.array([this.createZoneFormGroup()]),
    });
    if (!this.isEdit && this.zones.length === 0) {
      this.addZone();
    }

    FormUtils.setupDateChangeListeners(this.beachForm);
  }

  get zones(): FormArray {
    return this.beachForm.get("zones") as FormArray;
  }

  getLockTypes() {
    let user_id = this.Globals.user._id;
    let query = "?user_id=" + user_id;
    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.GET_LOCK_TYPE + query)
      .subscribe((res) => {
        this.locktypes = res.data;
      });
  }

  createZoneFormGroup(): FormGroup {
    const shouldDisableSubCategory =
      this.zoneTypes.length === 0 && !this.isEdit;

    const zoneGroup = this.fb.group({
      zoneName: ["", Validators.required],
      subCategoryId: [
        { value: "", disabled: shouldDisableSubCategory },
        Validators.required,
      ],
      numOfColumns: [
        null,
        [Validators.required, Validators.min(1), Validators.max(8)],
      ],
      numOfRows: [
        null,
        [Validators.required, Validators.min(1), Validators.max(8)],
      ],
      assetsIncluded: this.fb.array([this.createAssetControl()]),
      zoneImage: [null],
      price: [null, [Validators.required, Validators.min(0)]],
    });

    return zoneGroup;
  }

  debugSubcategoryState(): void {
    console.log("Zone Types:", this.zoneTypes);
    console.log("Selected Category:", this.beachForm.get("categoryId")?.value);
    console.log("Is Edit Mode:", this.isEdit);

    this.zones.controls.forEach((zone, index) => {
      const subCatControl = zone.get("subCategoryId");
      console.log(`Zone ${index} subCategory:`, {
        value: subCatControl?.value,
        disabled: subCatControl?.disabled,
        errors: subCatControl?.errors,
      });
    });
  }

  createAssetControl() {
    return this.fb.control("", Validators.required);
  }

  addZone(): void {
    const zoneFormGroup = this.createZoneFormGroup();
    this.zones.push(zoneFormGroup);
    this.zoneImagePreviews.push(null);

    const subCategoryControl = zoneFormGroup.get("subCategoryId");
    if (subCategoryControl) {
      if (this.zoneTypes.length > 0) {
        subCategoryControl.enable({ emitEvent: false });
      } else {
        subCategoryControl.disable({ emitEvent: false });
      }
      subCategoryControl.updateValueAndValidity();
    }
  }

  removeZone(index: number): void {
    if (index === 0) return;
    this.zones.removeAt(index);
    this.zoneImagePreviews.splice(index, 1);
  }

  openZoneModal(): void {
    this.modalService.open(this.zoneWarningModal, {
      centered: true,
      backdrop: "static",
    });
  }

  triggerZoneFileInput(zoneIndex: number): void {
    const fileInputs = this.zoneFileInputs.toArray();
    if (fileInputs[zoneIndex]) {
      fileInputs[zoneIndex].nativeElement.click();
    }
  }
  blockedDatesValidator(startDate: string, endDate: string) {
    return (formArray: AbstractControl): ValidationErrors | null => {
      if (!(formArray instanceof FormArray)) return null;
      const parentGroup = formArray.parent as FormGroup;
      if (!parentGroup) return null;

      if (this.isEdit) return null;

      const fromDate = new Date(parentGroup.get(startDate)?.value);
      const toDate = new Date(parentGroup.get(endDate)?.value);
      const selectedDates = formArray.value;
      const errors: any = {};
      const seen = new Set();

      for (let i = 0; i < selectedDates.length; i++) {
        const date = selectedDates[i];
        if (!date) continue;
        const dateStr = new Date(date).toISOString().split("T")[0];
        if (seen.has(dateStr)) {
          errors.duplicate = true;
          break;
        }
        seen.add(dateStr);

        if (!this.isEdit) {
          const d = new Date(dateStr);
          if (d < fromDate || d > toDate) {
            errors.outOfRange = true;
            break;
          }
        }
      }
      return Object.keys(errors).length ? errors : null;
    };
  }
  getAssetsArray(zoneIndex: number): FormArray {
    const zone = this.zones.at(zoneIndex) as FormGroup;
    return zone.get("assetsIncluded") as FormArray;
  }
  get availableRange(): { min?: string; max?: string } {
    const from = this.beachForm.get("startDate")?.value;
    const to = this.beachForm.get("endDate")?.value;

    return {
      min: from ? new Date(from).toISOString().split("T")[0] : undefined,
      max: to ? new Date(to).toISOString().split("T")[0] : undefined,
    };
  }

  shouldShowBlockedDates(): boolean {
    const from = this.beachForm.get("startDate")?.value;
    const to = this.beachForm.get("endDate")?.value;
    return !!from && !!to;
  }

  addAsset(zoneIndex: number): void {
    const assetsArray = this.getAssetsArray(zoneIndex);
    assetsArray.push(this.createAssetControl());
  }

  removeAsset(zoneIndex: number, assetIndex: number): void {
    const assetsArray = this.getAssetsArray(zoneIndex);
    if (assetsArray && assetsArray.length > 1) {
      assetsArray.removeAt(assetIndex);
    }
  }

  get beachBlockedDates(): FormArray {
    return this.beachForm.get("blockedDates") as FormArray;
  }

  addBlockedDate(): void {
    const validator = this.isEdit
      ? Validators.required
      : [Validators.required, CustomValidators.pastDateValidator];

    this.beachBlockedDates.push(this.fb.control("", validator));
  }
  removeImage(event: Event): void {
    event.stopPropagation();
    this.beachImage = null;
    this.imagePreview = null;
  }
  removeBlockedDate(dateIndex: number): void {
    this.beachBlockedDates.removeAt(dateIndex);
  }

  onFileChange(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.handleFile(event.target.files[0]);
    }
  }

  onZoneImageChange(event: any, zoneIndex: number): void {
    if (event.target.files && event.target.files.length > 0) {
      this.handleZoneFile(event.target.files[0], zoneIndex);
    }
  }

  private handleFile(file: File): void {
    this.beachImage = file;
    this.previewImage(file).then((preview) => {
      this.imagePreview = preview;
    });
  }

  private handleZoneFile(file: File, zoneIndex: number): void {
    this.zones.at(zoneIndex).patchValue({ zoneImage: file });
    this.previewImage(file).then((preview) => {
      this.zoneImagePreviews[zoneIndex] = preview;
    });
  }

  private previewImage(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.showLocationError = !this.selectedLocation;

    FormUtils.markFormGroupTouched(this.beachForm);

    if (!this.beachImage) {
      this.beachForm.setErrors({
        ...this.beachForm.errors,
        beachImageRequired: true,
      });
    }

    if (!this.selectedLocation) {
      this.beachForm.setErrors({
        ...this.beachForm.errors,
        locationRequired: true,
      });
    }

    if (this.zones.length === 0) {
      this.beachForm.setErrors({
        ...this.beachForm.errors,
        zoneRequired: true,
      });
      this.openZoneModal();
      return;
    }

    this.zones.controls.forEach((zone) => {
      if (zone instanceof FormGroup) {
        FormUtils.markFormGroupTouched(zone);
      }
    });

    if (this.beachForm.invalid) {
      return;
    }

    this.prepareAndSubmitFormData();
  }

  private prepareAndSubmitFormData(): void {
    const formData = new FormData();

    formData.append("beachImage", this.beachImage!);
    formData.append("assetType", this.beachForm.value.assetType);
    formData.append("title", this.beachForm.value.title);
    formData.append("description", this.beachForm.value.description);
    formData.append("address", this.beachForm.value.address);
    formData.append("latitude", this.beachForm.value.latitude);
    formData.append("longitude", this.beachForm.value.longitude);
    formData.append(
      "bookingLocationId",
      this.beachForm.value.bookingLocationId
    );
    formData.append("categoryId", this.beachForm.value.categoryId);
    formData.append("operator_id", this.operator_id);
    formData.append("startDate", this.beachForm.value.startDate);
    formData.append("endDate", this.beachForm.value.endDate);
    formData.append("checkInTime", this.beachForm.value.checkInTime);
    formData.append("checkOutTime", this.beachForm.value.checkOutTime);
    formData.append("timing", this.beachForm.value.timing);
    formData.append(
      "duration",
      this.beachForm.value.timing === "Full-day"
        ? "1"
        : this.beachForm.value.duration
    );
    formData.append("vatPercentage", this.beachForm.value.vatPercentage);
    formData.append("isExclusive", this.beachForm.value.isExclusive);

    formData.append(
      "blockedDates",
      JSON.stringify(this.beachForm.value.blockedDates)
    );

    const zones = this.zones.value.map((zone: any) => {
      console.log(
        "🚀 ~ BeachCreateBookingComponent ~ prepareAndSubmitFormData ~ zone:",
        zone
      );
      if (typeof zone.zoneImage === "string") {
        return { ...zone };
      } else {
        const { zoneImage, ...rest } = zone;
        return rest;
      }
    });

    formData.append("zones", JSON.stringify(zones));

    this.zones.value.forEach((zone: any) => {
      if (zone.zoneImage && typeof zone.zoneImage !== "string") {
        formData.append("zoneImage", zone.zoneImage);
      }
    });

    const url = this.isEdit
      ? `${ConfigApi.URLS.SPOT_BOOKING.UPDATE}/${this._id}`
      : ConfigApi.URLS.SPOT_BOOKING.CREATE;

    const method = this.isEdit ? "PUT" : "POST";

    // const formDataEntries = (formData as any).entries();
    // for (const pair of formDataEntries) {
    //   console.log(`${pair[0]}:`, pair[1]);
    // }

    this.apiCallingService.callAPI(formData, method, url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg);
          this.router.navigate(["/user/spot-booking"]);
        } else {
          this.toastr.error(res.msg);
        }
      },
      (err) => {
        this.toastr.error(err.error.msg, "Error");
      }
    );
  }

  initializeMap(): void {
    setTimeout(() => {
      const initialMarkerPosition =
        this.beachData && this.beachData.location && this.beachData.location
          ? {
              lat: this.beachData.location.coordinates[1],
              lng: this.beachData.location.coordinates[0],
            }
          : undefined;
      const mapInstance = MapUtils.initializeMap(
        "storeLocationMap",
        this.lat,
        this.lng,
        (lngLat, placeName) => {
          this.lat = lngLat.lat;
          this.lng = lngLat.lng;
          this.selectedLocation = placeName;
          this.showLocationError = false;
          this.beachForm.patchValue({
            address: this.selectedLocation,
            latitude: this.lat,
            longitude: this.lng,
          });
        },
        initialMarkerPosition
      );
      this.map = mapInstance.map;
    }, 100);
  }
  removeZoneImage(event: Event, zoneIndex: number): void {
    event.stopPropagation();
    this.zones.at(zoneIndex).patchValue({ zoneImage: null });
    this.zoneImagePreviews[zoneIndex] = null;
  }

  ngOnDestroy(): void {
    if (this.categoryChangeSubscription) {
      this.categoryChangeSubscription.unsubscribe();
    }
  }
}
